<template lang="pug">
  div
    h4 Precisamos que você confirme algumas informações
    br
    div(v-if="migrationHasAccessToEmail === null")
      label Você tem acesso a esse email?
      label Caso você esqueça a sua senha, você não poderá recuperar essa conta.
      label Se você não tem acesso a esse email, clique em
        strong &nbsp; não tenho acesso
        | &nbsp; e no próximo passo você poderá cadastrar um novo para essa conta da PontoTel.

      .two-grid
        button.btn.btn3d.btn-info.btn-sm(@click="migrationHasAccessToEmail = false") Não tenho acesso
        button.btn.btn3d.btn-success.btn-sm(@click="migrationHasAccessToEmail = true") Tenho acesso

    .form-group(v-if="migrationHasAccessToEmail !== null")
      div
        label.control-label
          | {{ migrationHasAccessToEmail ? 'Email' : 'Novo email' }}
          input.form-control(
            v-if="!migrationHasAccessToEmail"
            v-model="newEmail",
            @keydown="preventPaste",
            @contextmenu="preventRightClick"
          )

          input.form-control(
            v-else="",
            :value="email",
            :disabled="true",
            @keydown="preventPaste",
            @contextmenu="preventRightClick"
          )

        label.control-label(v-if="!migrationHasAccessToEmail")
          | Confirmar Email
          input.form-control(type="text", v-model="newEmailConfirm", :disabled="migrationHasAccessToEmail", @keydown="preventPaste", @contextmenu="preventRightClick")

      div
        label.control-label
          | Nova senha
          input.form-control(type="password", v-model="newPassword", @keydown="preventPaste", @contextmenu="preventRightClick")

        label.control-label
          | Confirmar senha
          input.form-control(type="password", v-model="newPasswordConfirm", @keydown="preventPaste", @contextmenu="preventRightClick")

      div(v-if="invalidPassword")
        label Essa senha não é valida. Você deve cadastrar uma senha com mais de 8 digídos, que contenha números e caracteres especiais.

      .two-grid
        button.btn.btn3d.btn-info.btn-sm(@click="migrationHasAccessToEmail = null") Voltar
        button.btn.btn3d.btn-success.btn-sm(@click="confirmMigration", :disabled="!valid") Confirmar

</template>

<script>
import Auth from '@aws-amplify/auth'

export default {
  props: {
    mp: { required: true, type: String },
    userInfoToMigrate: { required: true, type: Object }
  },
  data () {
    return {
      migrationHasAccessToEmail: null,
      newPassword: '',
      newPasswordConfirm: '',
      newEmail: '',
      newEmailConfirm: '',
      invalidPassword: false
    }
  },
  computed: {
    email () {
      return this.userInfoToMigrate.user.attributes.email
    },
    emaislMatch () {
      return this.migrationHasAccessToEmail ? true : this.newEmail === this.newEmailConfirm
    },
    passwordsMatch () {
      return this.newPassword === this.newPasswordConfirm
    },
    valid () {
      return this.emaislMatch && this.passwordsMatch
    }
  },
  methods: {
    async confirmMigration () {
      if (!this.valid) {
        return
      }

      const { user, userPoolId, userPoolWebClientId } = this.userInfoToMigrate

      this.$store.commit('cognitoTokens', {
        authorization: null,
        accessToken: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
        userPoolId,
        userPoolWebClientId
      })

      if (this.migrationHasAccessToEmail) {
        // Lets change the user password
        try {
          await Auth.changePassword(this.userInfoToMigrate.user, this.mp, this.newPassword)

          await this.$API.confirmMigrationUserCognito.save({ newEmail: null })

          await this.migratetWithSuccess('Senha alterada com sucesso.')
        } catch (e) {
          this.invalidPassword = true
        }
      } else {
        // update the password and email
        await Auth.changePassword(this.userInfoToMigrate.user, this.mp, this.newPassword)

        await this.$API.confirmMigrationUserCognito.save({ newEmail: this.newEmail })

        await this.migratetWithSuccess('Email e senha alterados com sucesso.')
      }
    },
    preventPaste (e) {
      if (e.ctrlKey && e.key.toLowerCase() === 'v') {
        e.preventDefault()
      }
    },
    preventRightClick (e) {
      e.preventDefault()
    },
    async migratetWithSuccess (text) {
      this.$swal({ type: 'success', text })

      await this.$store.dispatch('logout', false)
      this.$emit('successMigration')
    }
  }
}
</script>
